import React from "react";

export default function HosrseRacing() {
  return (
    <app-horse-racing _ngcontent-ng-c3019720824="" _nghost-ng-c1578363210="">
      <div _ngcontent-ng-c1578363210="">
        {/**/}
        {/**/}
        {/**/}
        <div
          _ngcontent-ng-c1578363210=""
          className="racing-tab hidden-xs homeevent"
          style={{ background: "#fff" }}
        >
          <div _ngcontent-ng-c1578363210="" className="row">
            <div _ngcontent-ng-c1578363210="" className="col-md-12">
              <div _ngcontent-ng-c1578363210="" className="horse-schedule">
                <h5 _ngcontent-ng-c1578363210="">Horse Racing Schedule</h5>
              </div>
            </div>
            <div
              _ngcontent-ng-c1578363210=""
              className="col-md-12 mobile-width"
            />
          </div>
          <div _ngcontent-ng-c1578363210="" className="ng-star-inserted">
            <ul
              _ngcontent-ng-c1578363210=""
              className="nav nav-tabs scrollflags"
            >
              <li _ngcontent-ng-c1578363210="" className="nav-item active">
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center align-items-center active"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <span _ngcontent-ng-c1578363210="">ALL</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/GB.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">GB</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/IRE.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">IRE</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/FRA.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">FRA</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/RSA.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">RSA</span>
                </a>
              </li>
              <li
                _ngcontent-ng-c1578363210=""
                className="nav-item ng-star-inserted"
              >
                <a
                  _ngcontent-ng-c1578363210=""
                  className="nav-link d-flex justify-content-center flex-column align-items-center"
                >
                  <span _ngcontent-ng-c1578363210="" />
                  <img
                    _ngcontent-ng-c1578363210=""
                    className="country-flag"
                    src="https://arrow444.com/assets/flags/USA.svg"
                  />
                  <span _ngcontent-ng-c1578363210="">USA</span>
                </a>
              </li>
              {/**/}
            </ul>
            {/**/}
            <div
              _ngcontent-ng-c1578363210=""
              className="matchList allmarkets ng-star-inserted"
            >
              {/**/}
              <div
                _ngcontent-ng-c1578363210=""
                className="tab-pane tab-pane-con ng-star-inserted"
              >
                <table
                  _ngcontent-ng-c1578363210=""
                  id="gameContainer"
                  className="table table-hover"
                >
                  <tbody _ngcontent-ng-c1578363210="">
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202491118198561/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Epsom</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          12-09-2024 22:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202491118198561"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418346365/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        <span
                          _ngcontent-ng-c1578363210=""
                          className="in_play ng-star-inserted"
                          style={{ background: "transparent !important" }}
                        >
                          In-Play
                        </span>
                        {/**/}
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418346365"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418348391/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 15:53{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418348391"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418441430/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:05{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418441430"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418349811/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:25{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418349811"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249241844336/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249241844336"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249241835371/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 16:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249241835371"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418444476/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418444476"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418354950/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:42{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418354950"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418104140/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418104140"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418446390/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 17:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418446390"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418112121/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:10{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418112121"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418356365/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:17{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418356365"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181042800/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:22{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181042800"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418447830/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:25{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418447830"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418127904/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418127904"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418113871/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418113871"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181121913/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181121913"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418358121/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418358121"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181044820/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 18:58{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181044820"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418449535/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418449535"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418129307/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:05{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418129307"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418115310/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418115310"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181123393/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:25{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181123393"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418359551/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Compiegne </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:27{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418359551"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181046560/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:33{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181046560"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249241845181/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:35{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249241845181"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181211142/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181211142"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418116997/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 19:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418116997"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181125222/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181125222"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249241847590/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:05{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249241847590"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181047760/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:08{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181047760"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418452432/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Greyville</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:10{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418452432"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181212583/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181212583"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418118313/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:25{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418118313"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181126713/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:35{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181126713"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249241849230/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249241849230"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181049561/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:43{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181049561"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181214383/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181214383"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181141513/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 20:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181141513"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418111073/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:02{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418111073"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418112872/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:10{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418112872"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181050960/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Perth </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181050960"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418410632/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418410632"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181216662/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:22{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181216662"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181143313/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181143313"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418111232/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:35{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418111232"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181129753/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:45{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181129753"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418412430/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:51{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418412430"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181218583/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Listowel </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 21:55{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181218583"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181144393/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181144393"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565557386/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565557386"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181113513/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Redcar</span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:10{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181113513"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565614546/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:10{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565614546"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565639356/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565639356"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181131832/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Goodwood </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:20{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181131832"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418413831/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:26{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418413831"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418114672/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418114672"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256555926/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256555926"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565715881/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565715881"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565616191/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:37{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565616191"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565641156/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:44{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565641156"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418415750/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:58{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418415750"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565717281/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 22:59{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565717281"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181147153/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181147153"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256560106/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256560106"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565617471/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:04{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565617471"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565642516/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:13{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565642516"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565718681/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:28{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565718681"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181149193/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181149193"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418417556/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418417556"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256561711/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256561711"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565618991/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:31{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565618991"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565736881/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565736881"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565644156/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:43{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565644156"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565720521/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565720521"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565620351/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          25-09-2024 23:58{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565620351"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181150513/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181150513"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256562867/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256562867"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492418418950/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Toulouse </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:02{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492418418950"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565738161/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:11{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565738161"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565645556/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565645556"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565721806/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:26{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565721806"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565621651/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:29{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565621651"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181152148/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181152148"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256564947/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256564947"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256588866/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256588866"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565739881/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:42{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565739881"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565647286/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:48{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565647286"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565723442/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:55{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565723442"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565624146/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:56{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565624146"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565810425/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 00:57{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565810425"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/7002024924181153408/7"
                        >
                          <span _ngcontent-ng-c1578363210="">Kempton </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 7002024924181153408"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256567271/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256567271"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565741241/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:13{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565741241"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565648727/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:20{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565648727"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565625656/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:23{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565625656"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565727401/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565727401"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565811835/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565811835"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256568990/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Delaware Park
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:30{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256568990"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565831985/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:35{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565831985"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565742921/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:44{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565742921"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256562826/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256562826"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565813985/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:51{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565813985"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565650436/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:52{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565650436"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/70020249256572981/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Finger Lakes{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 01:53{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 70020249256572981"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565836226/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:00{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565836226"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565744321/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565744321"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565629427/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Philadelphia{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:17{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565629427"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565815385/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:18{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565815385"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565651796/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Churchill Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:24{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565651796"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565838830/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:25{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565838830"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565817270/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:45{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565817270"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565746122/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:46{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565746122"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565841106/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 02:50{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565841106"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565818746/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 03:12{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565818746"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565842510/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 03:15{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565842510"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565747482/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Horseshoe Indianapolis{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 03:17{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565747482"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565820471/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Presque Isle Downs{" "}
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 03:39{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565820471"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565844145/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 03:40{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565844145"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <tr
                      _ngcontent-ng-c1578363210=""
                      className="firstElement ng-star-inserted"
                    >
                      <td _ngcontent-ng-c1578363210="" className="eventNametd">
                        <a
                          _ngcontent-ng-c1578363210=""
                          className="match-name"
                          href="/horse-racing/inplayHorseGame/700202492565845465/7"
                        >
                          <span _ngcontent-ng-c1578363210="">
                            Louisiana Downs
                          </span>
                        </a>
                        {/**/}
                        <p
                          _ngcontent-ng-c1578363210=""
                          className="match-time hidedate ng-star-inserted"
                        >
                          {" "}
                          26-09-2024 04:05{" "}
                        </p>
                        {/**/}
                      </td>
                      <td
                        _ngcontent-ng-c1578363210=""
                        className="ps-0"
                        style={{ width: 25 }}
                      >
                        <a
                          _ngcontent-ng-c1578363210=""
                          id="multiMarketPin"
                          title="Add to Multi Markets"
                          style={{ cursor: "pointer" }}
                          className="add-pin 700202492565845465"
                        >
                          <svg
                            _ngcontent-ng-c1578363210=""
                            xmlns="http://www.w3.org/2000/svg"
                            width={25}
                            height={25}
                            viewBox="0 0 25 25"
                          >
                            <path
                              _ngcontent-ng-c1578363210=""
                              fill="currentColor"
                              d="M12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.85 24 24 18.85 24 12.5S18.85 1 12.5 1 1 6.15 1 12.5 6.15 24 12.5 24zm5.09-12.078c1.606.516 2.41 1.13 2.41 2.19 0 .373-.067.616-.2.73-.135.115-.403.173-.804.173H13.57l-.81 7.988h-.536l-.795-7.988H6.003c-.4 0-.67-.065-.803-.194-.133-.128-.2-.364-.2-.708 0-1.06.804-1.674 2.41-2.19.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                    {/**/}
                  </tbody>
                </table>
              </div>
              {/**/}
            </div>
            {/**/}
          </div>
          {/**/}
          {/**/}
        </div>
      </div>
    </app-horse-racing>
  );
}
